<template>
    <div class="contents">
        <ToastProvider>
            <Header ref="header"></Header>
              <AddToCartToast
                v-show="isMobile"
                class="add-to-cart-toast fixed z-[99999999] right-[3.5%]"
                :style="{ top: `${computedTop}px` }"
                />
                
            <slot />

            <Footer></Footer>
            <Toast></Toast>
        </ToastProvider>
    </div>
    <AIChatPopupModal  :isBannerActive="isBannerActive" v-if="isChatEnabled" />
</template>

<script setup lang="ts">
const nuxtApp = useNuxtApp()
const config = nuxtApp.$config
import {ToastProvider} from 'radix-vue';
import Header from '~/components/app/header.vue';
import Footer from '~/components/app/footer.vue';
import Toast from '~/components/app/toast.vue';
import AIChatPopupModal from '~/components/ui/organism/AIChatPopupModal.vue';
import AddToCartToast from "~/components/app/AddToCartToast.vue";
import { onMounted, ref, computed } from 'vue'; 
import { useIframeStore } from '@/stores/chatAIStore';
import { useBreakpoints, breakpointsTailwind } from '@vueuse/core';
import { storeToRefs } from 'pinia';

const iframeStore = useIframeStore();
const localeStore = useLocaleStore()
const { annonceMentHeight} = storeToRefs(iframeStore);
const { locale } = storeToRefs(localeStore)


const breakPoints = useBreakpoints(breakpointsTailwind);
const isMobileBreakpoint = breakPoints.smaller('md'); 
const isMobile = ref(isMobileBreakpoint.value);
const header = ref(null);
const isBannerActive = ref(true)
const announcementBanner = ref(null);
const bannerHeight = ref(0)
const isChatEnabled = computed(() =>
  config?.public?.chatIframeEnabled === 'Y' &&
  (locale.value?.country?.taiaEnabled ?? false)
);
const computedTop = computed(() => {
  return (annonceMentHeight.value || 0) + 50;
});

</script>